export default "__VITE_ASSET__SfltirsE__"